module.exports = __webpack_public_path__ + "static/media/Play.4751200f.svg";